<!--
  <img src="{{ user?.avatar }}">
<div>
  <h4>{{ user?.name }}  </h4>
   
</div>
-->
 
<div *ngIf="chat" class="chat-wrapper">


 <div style="position:absolute; left: 60px;   top: 20px;  z-index:77;"><span ><a href="javascript:;" (click)="openBlackLish()"  ><nb-icon [icon]="'slash-outline'" pack="eva"></nb-icon></a></span><span *ngIf="openSettingsCb" style="margin-left:10px;" ><a href="javascript:;" (click)="openSettings()"  ><nb-icon [icon]="'settings-outline'" pack="eva"></nb-icon></a></span>
<span *ngIf="openSettingsCb" style="margin-left:10px;" ><a href="javascript:;" (click)="download()"  ><nb-icon [icon]="'download-outline'" pack="eva"></nb-icon></a></span>
</div>

  <div class="enableToggle">   

     <nb-toggle  
     labelPosition="left"
      [(checked)]="chatEnabled" 
      (checkedChange)="toggleEnabled()" 
      status="primary">
      <span *ngIf="chatEnabled">Включений</span>
      <span *ngIf="!chatEnabled">Відключений</span>
    </nb-toggle>

  </div>

<nb-chat style="margin-bottom:1rem !important;"   [noMessagesPlaceholder]="'Повідомлень поки немає'" [title]="'Чат'"  >
    <nb-chat-message class="innerchat"  [class.opacityChat]="!chatEnabled" [class.selected]="selectedMessage === msg"  *ngFor="let msg of messages"
                     [dateFormat]="'(yyyy-MM-dd HH:mm:ss)'"
                     [type]="msg.type"
                     [message]="msg.text"
                     [reply]="msg.reply"
                     [sender]="msg.user.name" 
                     [date]="msg.date"
 
 			(click)="selectItem($event,msg)"
                     [avatar]="msg.user.avatar"  > 
    </nb-chat-message>
    <nb-chat-form  *ngIf="chatEnabled" [messagePlaceholder]="'Введіть текст повідомлення'" (send)="sendMessage($event)" [dropFiles]="true">
    </nb-chat-form>
    </nb-chat> 


	<div *ngIf="selectedMessage"(click)="$event.stopPropagation()" class="barControls themeBg">

	<button nbButton  size="tiny" (click)="selectedMessageControl('delete')" status="danger">Видалити</button>
	<button nbButton   size="tiny" *ngIf="selectedMessage.socialId !== stream.user" (click)="selectedMessageControl('ban')" status="danger">Заблокувати</button>
	<button nbButton   size="tiny" (click)="selectedMessageControl('cancel')"  >Скасувати</button>

</div>
    
  </div>
